// Brand assets and constants for Daos Ads
export const BRAND = {
  name: "Daos Ads",
  slogan: "Gana más, pierde cero.",
  whatsappNumber: "+50243376954",
  whatsappE164: "50243376954",
  email: "David.osorio@daosads.com",
  respondAffiliate: "https://get.respond.io/x6kdmon9dn87",
  socials: {
    instagram: "https://www.instagram.com/daos.ads/",
    facebook: "https://www.facebook.com/daosads",
    tiktok: "https://www.tiktok.com/@daosads",
  },
  logo: "https://customer-assets.emergentagent.com/job_791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/artifacts/vxx2qxkz_5.png",
  photo:
    "https://customer-assets.emergentagent.com/job_791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/artifacts/5urzvthr_David%20Osorio%20-%20Fotografia%20%281%29%20%282%29.jpg",
  images: {
    dashboard:
      "https://static.prod-images.emergentagent.com/jobs/791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/images/7f3b14694e39f1abec808bf43b103b913b6ba4b440a79dd30351bc63906911d2.png",
    aiBackground:
      "https://static.prod-images.emergentagent.com/jobs/791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/images/9e0cf8c1d52afbe60560df29f7dbcde2bc288462225754c4c27277b08836719b.png",
    funnel:
      "https://static.prod-images.emergentagent.com/jobs/791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/images/783d8ae5e26b54a63f9983435ee9752fc746a05af2a9252005239f3a9b17107d.png",
    texture:
      "https://static.prod-images.emergentagent.com/jobs/791cc221-61ed-4c3e-8c20-ef0f4d6cb1c3/images/39e6a3fb09ec33c59d2660a770121f345e6880f077e84d3ad8585d140b207d39.png",
  },
};

export const waLink = (text = "Hola David, vengo desde la web de Daos Ads y quiero automatizar mi negocio.") =>
  `https://wa.me/${BRAND.whatsappE164}?text=${encodeURIComponent(text)}`;
